/* player-fit-quiz.js — Cues and More Player Fit Quiz Engine */
(function () {
  'use strict';

  // ================================================================
  // QUIZ QUESTIONS
  // ================================================================

  var QUESTIONS = [
    {
      index: 0, section: 'A', sectionTitle: 'Your Playing Profile',
      text: 'How would you describe your experience level?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Brand new', tag: 'skill=beginner' },
        { label: 'Casual', tag: 'skill=casual' },
        { label: 'Developing', tag: 'skill=intermediate' },
        { label: 'Competitive', tag: 'skill=competitive' },
        { label: 'Advanced / Semi-Pro', tag: 'skill=advanced' }
      ]
    },
    {
      index: 1, section: 'A', sectionTitle: 'Your Playing Profile',
      text: 'Which games do you play? (Select all that apply)',
      multi: true, tooltip: null,
      answers: [
        { label: '8-Ball', tag: 'game=8ball' },
        { label: '9/10-Ball', tag: 'game=9ball' },
        { label: 'Straight Pool', tag: 'game=straight' },
        { label: 'Snooker', tag: 'game=snooker' },
        { label: 'Bar Pool / Coin-Op', tag: 'game=barbox' }
      ]
    },
    {
      index: 2, section: 'A', sectionTitle: 'Your Playing Profile',
      text: 'How often do you play?',
      multi: false, tooltip: null,
      answers: [
        { label: 'A few times a year', tag: 'freq=rare' },
        { label: 'Monthly', tag: 'freq=occasional' },
        { label: 'Weekly / bi-weekly', tag: 'freq=regular' },
        { label: 'Multiple times a week', tag: 'freq=serious' },
        { label: 'Daily / near daily', tag: 'freq=daily' }
      ]
    },
    {
      index: 3, section: 'A', sectionTitle: 'Your Playing Profile',
      text: 'Where do you play most?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Pool halls / billiard rooms', tag: 'venue=poolhall' },
        { label: 'Bar tables (coin-op)', tag: 'venue=bar' },
        { label: 'Home table', tag: 'venue=home' },
        { label: 'Mix of hall and bar', tag: 'venue=mixed' },
        { label: 'League venues / tournaments', tag: 'venue=league' }
      ]
    },
    {
      index: 4, section: 'B', sectionTitle: 'Your Game & Style',
      text: 'How would you describe your shooting style?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Power / force', tag: 'style=power' },
        { label: 'Control / finesse', tag: 'style=finesse' },
        { label: 'Heavy spin', tag: 'style=spin' },
        { label: 'Balanced', tag: 'style=balanced' },
        { label: 'Still developing my style', tag: 'style=developing' }
      ]
    },
    {
      index: 5, section: 'B', sectionTitle: 'Your Game & Style',
      text: 'How comfortable are you using English (side spin)?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Rarely or never use it', tag: 'english=none' },
        { label: 'I use it on obvious shots', tag: 'english=occasional' },
        { label: 'I use it consistently as part of my position play', tag: 'english=consistent' },
        { label: 'Heavy English is a core part of my game', tag: 'english=heavy' }
      ]
    },
    {
      index: 6, section: 'B', sectionTitle: 'Your Game & Style',
      text: 'What is your bridge preference?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Open bridge (mechanical bridge or rest) often', tag: 'grip=open' },
        { label: 'Closed bridge, firm wrap', tag: 'grip=closed' },
        { label: 'Open bridge, light touch', tag: 'grip=openlight' },
        { label: 'No strong preference yet', tag: 'grip=none' }
      ]
    },
    {
      index: 7, section: 'B', sectionTitle: 'Your Game & Style',
      text: 'How would you describe your stroke type?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Short, punchy strokes', tag: 'stroke=short' },
        { label: 'Long, smooth follow-through', tag: 'stroke=long' },
        { label: 'Variable — depends on the shot', tag: 'stroke=variable' },
        { label: "I haven't thought about it", tag: 'stroke=unknown' }
      ]
    },
    {
      index: 8, section: 'B', sectionTitle: 'Your Game & Style',
      text: 'What table size do you play most?',
      multi: false, tooltip: null,
      answers: [
        { label: '7-foot (bar box)', tag: 'table=7ft' },
        { label: '8-foot', tag: 'table=8ft' },
        { label: '9-foot (regulation)', tag: 'table=9ft' },
        { label: 'Snooker table', tag: 'table=snooker' },
        { label: "Mixed / don't know", tag: 'table=mixed' }
      ]
    },
    {
      index: 9, section: 'C', sectionTitle: 'Your Cue',
      text: "What's your cue situation?",
      multi: false, tooltip: null,
      answers: [
        { label: 'I need my first cue', tag: 'cueown=first' },
        { label: 'Upgrading a house cue', tag: 'cueown=upgrade' },
        { label: 'Replacing a worn-out personal cue', tag: 'cueown=replace' },
        { label: 'Adding a specialty cue', tag: 'cueown=specialty' },
        { label: "I'm a collector — always looking", tag: 'cueown=collector' }
      ]
    },
    {
      index: 10, section: 'C', sectionTitle: 'Your Cue',
      text: "What's your cue budget?",
      multi: false, tooltip: null,
      answers: [
        { label: 'Under $100', tag: 'cuebudget=entry' },
        { label: '$100–$200', tag: 'cuebudget=low' },
        { label: '$200–$350', tag: 'cuebudget=mid' },
        { label: '$350–$500', tag: 'cuebudget=upper' },
        { label: '$500–$700', tag: 'cuebudget=high' },
        { label: '$700+', tag: 'cuebudget=premium' }
      ]
    },
    {
      index: 11, section: 'C', sectionTitle: 'Your Cue',
      text: 'How do you feel about low-deflection (LD) shafts?',
      multi: false,
      tooltip: 'A low-deflection shaft curves less when you apply side spin, making cue ball control more predictable. Usually carbon fiber or engineered wood. Typically $130–$500 extra.',
      answers: [
        { label: "What's an LD shaft?", tag: 'ld=unknown' },
        { label: "I've heard of it but haven't tried one", tag: 'ld=curious' },
        { label: "I'm interested — could help with my game", tag: 'ld=interested' },
        { label: 'I already play LD and want an upgrade', tag: 'ld=upgrade' },
        { label: 'Not interested', tag: 'ld=no' }
      ]
    },
    {
      index: 12, section: 'C', sectionTitle: 'Your Cue',
      text: 'Do you have a cue weight preference?',
      multi: false,
      tooltip: 'Light = 17–18 oz (finesse/control players), Standard = 19–20 oz (most players), Heavy = 21+ oz (power players). You can usually adjust weight with a bolt in the handle.',
      answers: [
        { label: 'Light (17–18 oz)', tag: 'weight=light' },
        { label: 'Standard (19–20 oz)', tag: 'weight=standard' },
        { label: 'Heavy (21 oz+)', tag: 'weight=heavy' },
        { label: "I don't know yet", tag: 'weight=unknown' }
      ]
    },
    {
      index: 13, section: 'D', sectionTitle: 'Your Case & Transport',
      text: 'How do you travel with your cue?',
      multi: false, tooltip: null,
      answers: [
        { label: 'I walk or take transit', tag: 'transport=walk' },
        { label: 'I drive — cue goes in the back seat or trunk', tag: 'transport=drive' },
        { label: 'I fly for tournaments', tag: 'transport=fly' },
        { label: 'Mostly stays at home or the club', tag: 'transport=home' }
      ]
    },
    {
      index: 14, section: 'D', sectionTitle: 'Your Case & Transport',
      text: 'Are you open to cues or accessories designed with women players in mind?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Yes — I specifically look for women-forward designs and lighter builds', tag: 'gender=women' },
        { label: 'Open to it if it performs well', tag: 'gender=open' },
        { label: 'No — not relevant or not my preference', tag: 'gender=no' },
        { label: 'Not a factor for me — I just want the best fit', tag: 'gender=neutral' }
      ]
    },
    {
      index: 15, section: 'D', sectionTitle: 'Your Case & Transport',
      text: 'How much case capacity do you need?',
      multi: false, tooltip: null,
      answers: [
        { label: '1 cue, minimal accessories', tag: 'capacity=minimal' },
        { label: '1 cue + break cue or 2-piece set', tag: 'capacity=dual' },
        { label: '2–4 cues + accessories', tag: 'capacity=multi' },
        { label: '4+ cues — I need real capacity', tag: 'capacity=max' }
      ]
    },
    {
      index: 16, section: 'E', sectionTitle: 'Budget & Accessories',
      text: 'What is your total accessory budget beyond the cue?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Under $50', tag: 'accbudget=minimal' },
        { label: '$50–$100', tag: 'accbudget=moderate' },
        { label: '$100–$200', tag: 'accbudget=solid' },
        { label: '$200+', tag: 'accbudget=full' }
      ]
    },
    {
      index: 17, section: 'E', sectionTitle: 'Budget & Accessories',
      text: 'Do you use a billiard glove?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Yes, always', tag: 'glove=yes' },
        { label: 'Occasionally', tag: 'glove=occasional' },
        { label: 'Never tried one', tag: 'glove=curious' },
        { label: 'No', tag: 'glove=no' }
      ]
    },
    {
      index: 18, section: 'E', sectionTitle: 'Budget & Accessories',
      text: 'What tip hardness do you prefer?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Soft — maximum spin transfer', tag: 'tip=soft' },
        { label: 'Medium — balanced feel', tag: 'tip=medium' },
        { label: 'Hard — durability and precision', tag: 'tip=hard' },
        { label: 'I use whatever came on the cue', tag: 'tip=default' },
        { label: "I've never changed a tip", tag: 'tip=unknown' }
      ]
    },
    {
      index: 19, section: 'F', sectionTitle: 'Style & Aesthetics',
      text: 'What is your visual style preference for a cue?',
      multi: false, tooltip: null,
      answers: [
        { label: 'Classic and understated — wood grain, subtle inlays', tag: 'look=classic' },
        { label: 'Bold and distinctive — I want my cue to stand out', tag: 'look=bold' },
        { label: 'Sleek and modern — carbon fiber look, clean lines', tag: 'look=modern' },
        { label: 'Artistic — intricate inlays, detailed artwork', tag: 'look=artistic' },
        { label: 'I care more about performance than looks', tag: 'look=performance' }
      ]
    }
  ];

  // ================================================================
  // PLAYER PROFILES
  // ================================================================

  var PROFILES = {
    'beginner-rare':     { name: 'New Explorer', desc: "You're just picking up a cue and finding your footing. Pool is a great time—no pressure to get technical yet. What matters most is a forgiving, comfortable cue at a fair price. We'll point you toward proven starter cues that hold up well and won't hold you back as you improve." },
    'beginner-occasional': { name: 'Casual Newcomer', desc: "You play for fun and keep it relaxed. A solid mid-range cue will make a noticeable difference over a house cue without requiring a big commitment. Focus on feel, balance, and a tip that grips the ball reliably." },
    'beginner-regular':  { name: 'Enthusiastic Beginner', desc: "You're getting out regularly and building real muscle memory. This is the stage where the right cue starts to matter—a balanced weight, consistent tip, and straight shaft will help you develop faster. We'll show you gear that grows with your game." },
    'beginner-serious':  { name: 'Dedicated Beginner', desc: "You're putting serious time in at the table. That kind of practice deserves gear that keeps up. Look for a well-constructed cue in the $150–$300 range with a quality tip and tight tolerances." },
    'beginner-daily':    { name: 'Aspiring Player', desc: "Daily practice at this stage is how breakthroughs happen. A cue with a quality shaft and consistent tip will help you build repeatable mechanics. Consider a cue that offers upgradeable shafts as your game advances." },
    'casual-rare':       { name: 'Social Player', desc: "Pool is a social activity for you—fun, relaxed, no scoreboard required. A clean cue that looks good and feels comfortable is all you need. We'll find you something in the $75–$200 range that'll impress at the bar table." },
    'casual-occasional': { name: 'Casual Enthusiast', desc: "You enjoy pool as a regular hobby and you're starting to notice the difference between a good cue and a house stick. A step-up cue with a quality tip and balanced feel will noticeably improve your consistency." },
    'casual-regular':    { name: 'Weekend Warrior', desc: "Pool is a regular part of your routine and you're building real skills. A mid-range cue with tight construction will start rewarding good technique. This is a great time to think about tip hardness and shaft taper." },
    'casual-serious':    { name: 'Avid Casual', desc: "You put in real table time even though you keep things informal. Equipment quality is starting to matter—a well-balanced cue with a quality shaft will help you shoot more consistently and hold your own against stronger players." },
    'casual-daily':      { name: 'Daily Enthusiast', desc: "Playing every day, even casually, builds serious instincts. A cue in the $200–$400 range with a performance-grade tip will let your natural development show up in your results." },
    'intermediate-rare': { name: 'Rusty Technician', desc: "You know the game deeply but life keeps you away from the table. When you play, you want gear that rewards your technical knowledge—a quality shaft and familiar tip hardness will get you back into rhythm fast." },
    'intermediate-occasional': { name: 'Developing Player', desc: "You have a solid foundation and are actively thinking about your game. A cue in the $200–$400 range with a quality joint and shaft will reward your technical skills and give you room to keep growing." },
    'intermediate-regular':    { name: 'Developing Competitor', desc: "You play consistently and actively work to improve. You understand fundamentals and are ready for a cue that rewards good technique—tighter tolerances, quality ferrule system, and a shaft that complements your style." },
    'intermediate-serious':    { name: 'Dedicated Intermediate', desc: "You practice regularly and compete in leagues or local tournaments. Your game is solid and you need equipment that keeps pace. A performance-oriented mid-to-upper cue will help you take the next step." },
    'intermediate-daily':      { name: 'League Contender', desc: "You're at the table every day and your game shows it. This is the level where shaft technology—deflection, flex, ferrule material—starts making a real difference. Consider a cue with an upgradeable LD shaft." },
    'competitive-rare':   { name: 'Part-Time Competitor', desc: "You compete when you can and you take it seriously. Despite limited table time, your technical background means you need gear that meets competitive standards—tight construction, quality shaft, and a reliable tip." },
    'competitive-occasional': { name: 'Tournament Regular', desc: "You compete in regional tournaments and your equipment needs to match that level. Cues in the $350–$700 range with performance shafts are your territory. A low-deflection shaft could give you a real edge." },
    'competitive-regular':    { name: 'Competitive Player', desc: "You compete regularly and take your game seriously. You understand shaft deflection, tip hardness, and cue balance—you need equipment that matches your precision. Look for tournament-grade builds with tight tolerances." },
    'competitive-serious':    { name: 'Serious Competitor', desc: "You train seriously and compete at a high level. Equipment is a competitive advantage. A premium cue with a performance LD shaft, quality tip, and consistent weight is not a luxury—it's the baseline." },
    'competitive-daily':      { name: 'Elite Amateur', desc: "Daily training at the competitive level demands elite gear. You know exactly what you need in a cue—deflection characteristics, tip response, shaft taper. We'll show you the top-end options that match your precision." },
    'advanced-rare':   { name: 'Seasoned Veteran', desc: "Years of high-level play mean you know what you want in a cue. Even with less table time now, your standards are high. Premium shafts, quality tips, and refined construction—that's your baseline." },
    'advanced-occasional': { name: 'Advanced Player', desc: "Advanced technique deserves advanced equipment. Cues in the $500–$1,000+ range with top-tier shafts and precision-crafted joints will meet your standards and reward your skills." },
    'advanced-regular':    { name: 'Advanced Competitor', desc: "You compete at an advanced level and train consistently. Elite cues, premium LD shafts, and performance tips are your tools. We'll surface the best options for your style and game." },
    'advanced-serious':    { name: 'Semi-Pro Contender', desc: "You train at semi-professional intensity. Gear performance is everything—shaft deflection, tip hardness, joint fit, balance point. We'll show you the premium options that match your game." },
    'advanced-daily':      { name: 'Elite Player', desc: "You train daily at the highest amateur or professional level. Equipment is a precision instrument. Only the finest shafts, most consistent tips, and best-crafted cues make this list for you." }
  };

  var PROFILE_DEFAULT = { name: 'Billiards Enthusiast', desc: "Based on your answers, we've put together a curated selection of cues, cases, and accessories to match your style and goals. Every recommendation is available at Cues and More." };

  // ================================================================
  // BUDGET & TAG CONFIG
  // ================================================================

  var BUDGET_RANGES = {
    entry:   [0,     99.99],
    low:     [50,    220],
    mid:     [150,   380],
    upper:   [300,   550],
    high:    [450,   750],
    premium: [500,   99999]
  };

  var TAG_ORDER = {
    skill:     ['beginner', 'casual', 'intermediate', 'competitive', 'advanced'],
    freq:      ['rare', 'occasional', 'regular', 'serious', 'daily'],
    cuebudget: ['entry', 'low', 'mid', 'upper', 'high', 'premium'],
    accbudget: ['minimal', 'moderate', 'solid', 'full'],
    weight:    ['light', 'standard', 'heavy'],
    english:   ['none', 'occasional', 'consistent', 'heavy']
  };

  // ================================================================
  // STATE
  // ================================================================

  var state = { step: 0, answers: {}, tags: [], done: false };
  var historyStack = [];

  function resetState() {
    state = { step: 0, answers: {}, tags: [], done: false };
    historyStack = [];
  }

  function pushHistory() {
    historyStack.push({
      step: state.step,
      answers: JSON.parse(JSON.stringify(state.answers)),
      tags: state.tags.slice()
    });
  }

  function popHistory() {
    if (!historyStack.length) return false;
    var prev = historyStack.pop();
    state.step = prev.step;
    state.answers = prev.answers;
    state.tags = prev.tags;
    return true;
  }

  // ================================================================
  // UTILITIES
  // ================================================================

  function getTagValue(tags, key) {
    var prefix = key + '=';
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf(prefix) === 0) return tags[i].slice(prefix.length);
    }
    return null;
  }

  function normalizeProductTag(tag) {
    var lower = tag.toLowerCase().trim();
    if (lower.indexOf('quiz-') !== 0) return null;
    var rest = lower.slice(5);
    var dash = rest.indexOf('-');
    if (dash < 0) return null;
    return rest.slice(0, dash) + '=' + rest.slice(dash + 1);
  }

  function getProductNormalizedTags(product) {
    return (product.tags || []).map(normalizeProductTag).filter(Boolean);
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function isAdjacentMatch(quizTag, productTag) {
    var qParts = quizTag.split('=');
    var pParts = productTag.split('=');
    if (qParts[0] !== pParts[0]) return false;
    var order = TAG_ORDER[qParts[0]];
    if (!order) return false;
    var qi = order.indexOf(qParts[1]);
    var pi = order.indexOf(pParts[1]);
    return qi >= 0 && pi >= 0 && Math.abs(qi - pi) === 1;
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'class') node.className = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      children.forEach(function (c) {
        if (c) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  // ================================================================
  // RECOMMENDATION ENGINE
  // ================================================================

  function getCueBudgetRange(tags) {
    var tier = getTagValue(tags, 'cuebudget');
    return tier && BUDGET_RANGES[tier] ? BUDGET_RANGES[tier] : null;
  }

  function filterCues(products, tags) {
    var priceCents = getCueBudgetRange(tags);
    var barbox = tags.indexOf('game=barbox') >= 0 && tags.indexOf('table=7ft') >= 0;
    var ldNo = tags.indexOf('ld=no') >= 0;
    var genderWomen = tags.indexOf('gender=women') >= 0;

    return products.filter(function (p) {
      var ptype = (p.type || '').toLowerCase();
      if (ptype !== 'cue') return false;
      var ptags = getProductNormalizedTags(p);

      if (priceCents) {
        var priceUsd = p.price / 100;
        if (priceUsd < priceCents[0] || priceUsd > priceCents[1]) return false;
      }
      if (barbox && ptags.indexOf('length=full') >= 0) return false;
      if (ldNo && ptags.indexOf('type=ld') >= 0) return false;
      if (genderWomen) {
        var hasWomen = ptags.some(function (t) { return t.indexOf('gender=') === 0; });
        if (hasWomen && ptags.indexOf('gender=women') < 0) return false;
      }
      return true;
    });
  }

  function filterCases(products, tags) {
    var transport = getTagValue(tags, 'transport');
    var capacity = getTagValue(tags, 'capacity');

    return products.filter(function (p) {
      var ptype = (p.type || '').toLowerCase();
      if (ptype !== 'cue case') return false;
      var ptags = getProductNormalizedTags(p);

      if (transport === 'fly') {
        var hasHard = ptags.some(function (t) { return t === 'casetype=hard' || t === 'casetype=semihard'; });
        if (!hasHard && ptags.some(function (t) { return t.indexOf('casetype=') === 0; })) return false;
      }
      if (transport === 'walk') {
        var hasHardWalk = ptags.indexOf('casetype=hard') >= 0;
        if (hasHardWalk) return false;
      }
      if (capacity) {
        var hasCap = ptags.some(function (t) { return t.indexOf('capacity=') === 0; });
        if (hasCap && ptags.indexOf('capacity=' + capacity) < 0) return false;
      }
      return true;
    });
  }

  function filterAccessories(products, tags) {
    var accBudgetTier = getTagValue(tags, 'accbudget');
    var accRanges = { minimal: [0, 30], moderate: [0, 60], solid: [0, 120], full: [0, 9999] };
    var range = accBudgetTier && accRanges[accBudgetTier] ? accRanges[accBudgetTier] : [0, 9999];
    var noGlove = tags.indexOf('glove=no') >= 0;

    return products.filter(function (p) {
      var ptype = (p.type || '').toLowerCase();
      var isAcc = ptype === 'chalk' || ptype === 'tip tool' || ptype === 'accessory';
      if (!isAcc) return false;
      if (noGlove) {
        var ptags = getProductNormalizedTags(p);
        if (ptags.indexOf('type=glove') >= 0) return false;
      }
      var priceUsd = p.price / 100;
      return priceUsd >= range[0] && priceUsd <= range[1];
    });
  }

  function filterShafts(products, tags) {
    var ldTier = getTagValue(tags, 'ld');
    if (!ldTier || ldTier === 'no') return [];
    return products.filter(function (p) {
      return (p.type || '').toLowerCase() === 'shaft';
    });
  }

  function scoreProducts(products, tags) {
    return products.map(function (p) {
      var ptags = getProductNormalizedTags(p);
      var score = 0;
      tags.forEach(function (qt) {
        ptags.forEach(function (pt) {
          if (qt === pt) score += 2;
          else if (isAdjacentMatch(qt, pt)) score += 1;
        });
      });
      return { product: p, score: score };
    }).sort(function (a, b) { return b.score - a.score; });
  }

  function getRecommendations(tags) {
    var products = (window.CuesAndMore && window.CuesAndMore.products) || [];

    var cueFiltered = filterCues(products, tags);
    var cueScored = scoreProducts(cueFiltered, tags);
    var cues = cueScored.slice(0, 5).map(function (s) { return s.product; });

    if (cues.length < 3) {
      var relaxedTier = relaxBudgetTier(getTagValue(tags, 'cuebudget'));
      if (relaxedTier) {
        var relaxedTags = tags.filter(function (t) { return t.indexOf('cuebudget=') < 0; }).concat(['cuebudget=' + relaxedTier]);
        var fallback = filterCues(products, relaxedTags);
        var fbScored = scoreProducts(fallback, relaxedTags);
        var fbProducts = fbScored.map(function (s) { return s.product; });
        fbProducts.forEach(function (p) {
          if (cues.length < 5 && !cues.some(function (c) { return c.id === p.id; })) {
            cues.push(p);
          }
        });
      }
    }

    var caseFiltered = filterCases(products, tags);
    var caseScored = scoreProducts(caseFiltered, tags);
    var cases = caseScored.slice(0, 3).map(function (s) { return s.product; });

    var shafts = filterShafts(products, tags);
    var shaftScored = scoreProducts(shafts, tags);
    var ldTier = getTagValue(tags, 'ld');
    var maxShafts = ldTier === 'upgrade' ? 2 : ldTier === 'interested' ? 3 : 1;
    if (ldTier === 'upgrade') {
      shafts = shaftScored.filter(function (s) {
        var pt = getProductNormalizedTags(s.product);
        return pt.indexOf('material=carbon') >= 0 || pt.indexOf('type=carbon') >= 0;
      }).slice(0, 2).map(function (s) { return s.product; });
    } else {
      shafts = shaftScored.slice(0, maxShafts).map(function (s) { return s.product; });
    }

    var accFiltered = filterAccessories(products, tags);
    var accScored = scoreProducts(accFiltered, tags);
    var accessories = accScored.slice(0, 8).map(function (s) { return s.product; });

    return { cues: cues, cases: cases, shafts: shafts, accessories: accessories };
  }

  function relaxBudgetTier(tier) {
    var tiers = ['entry', 'low', 'mid', 'upper', 'high', 'premium'];
    var idx = tiers.indexOf(tier);
    if (idx < 0) return null;
    if (idx > 0) return tiers[idx - 1];
    if (idx < tiers.length - 1) return tiers[idx + 1];
    return null;
  }

  // ================================================================
  // PROFILE & GUIDANCE
  // ================================================================

  function getProfile(tags) {
    var skill = getTagValue(tags, 'skill') || 'intermediate';
    var freq = getTagValue(tags, 'freq') || 'regular';
    return PROFILES[skill + '-' + freq] || PROFILE_DEFAULT;
  }

  function getWeightGuidance(tags) {
    var weight = getTagValue(tags, 'weight');
    var style = getTagValue(tags, 'style');
    if (weight === 'light') return { range: '17–18 oz', explanation: 'Light cues give finesse players more touch and control on soft shots.' };
    if (weight === 'heavy') return { range: '21+ oz', explanation: 'Heavier cues naturally drive through the ball and suit a power-forward stroke.' };
    if (weight === 'standard' || style === 'balanced' || style === 'developing') {
      return { range: '19–20 oz', explanation: 'Standard weight suits most players and games—balanced feel, easy to adjust.' };
    }
    if (style === 'power') return { range: '19–21 oz', explanation: 'Power players often prefer a heavier cue to keep the stroke smooth and controlled.' };
    if (style === 'finesse' || style === 'spin') return { range: '17–19 oz', explanation: 'Finesse and spin players typically favor a lighter cue for more feel on delicate shots.' };
    return { range: '18–20 oz', explanation: 'A mid-weight cue gives you flexibility across different shot types.' };
  }

  function getShaftDiameterGuidance(tags) {
    var game = getTagValue(tags, 'game');
    var style = getTagValue(tags, 'style');
    var english = getTagValue(tags, 'english');
    if (game === 'snooker') return { range: '9–10 mm', explanation: 'Snooker shafts are significantly narrower, designed for the precision and touch the game demands.' };
    if (style === 'finesse' || style === 'spin' || english === 'heavy' || english === 'consistent') {
      return { range: '12–12.5 mm', explanation: 'A narrower shaft gives more feel and reduces deflection when applying heavy spin.' };
    }
    if (style === 'power') return { range: '13 mm+', explanation: 'A wider tip contacts more of the cue ball, which suits a hard-driving power stroke.' };
    return { range: '12.75–13 mm', explanation: 'Standard shaft diameter—works well across all styles and suits most players.' };
  }

  function generateBlurb(product, tags) {
    var ptags = getProductNormalizedTags(product);
    var reasons = [];

    var skill = getTagValue(tags, 'skill');
    var style = getTagValue(tags, 'style');
    var look = getTagValue(tags, 'look');
    var game = getTagValue(tags, 'game');
    var ld = getTagValue(tags, 'ld');
    var budget = getTagValue(tags, 'cuebudget');

    if (skill && ptags.indexOf('skill=' + skill) >= 0) {
      var skillLabels = { beginner: 'ideal for new players', casual: 'great for casual play', intermediate: 'built for developing players', competitive: 'competition-ready', advanced: 'elite-level craftsmanship' };
      if (skillLabels[skill]) reasons.push(skillLabels[skill]);
    }
    if (style && ptags.indexOf('style=' + style) >= 0) {
      var styleLabels = { power: 'engineered for power play', finesse: 'optimized for cue ball control', spin: 'excellent English responsiveness', balanced: 'versatile all-around performer' };
      if (styleLabels[style]) reasons.push(styleLabels[style]);
    }
    if (look && ptags.indexOf('look=' + look) >= 0) {
      var lookLabels = { classic: 'classic wood grain aesthetics', bold: 'bold standout design', modern: 'sleek modern finish', artistic: 'stunning artistic inlays' };
      if (lookLabels[look]) reasons.push(lookLabels[look]);
    }
    if (game === 'snooker' && ptags.indexOf('game=snooker') >= 0) reasons.push('purpose-built for snooker');
    if ((ld === 'upgrade' || ld === 'interested') && ptags.indexOf('type=ld') >= 0) reasons.push('features a low-deflection shaft');
    if ((budget === 'entry' || budget === 'low') && ptags.some(function (t) { return t === 'cuebudget=entry' || t === 'cuebudget=low'; })) {
      reasons.push('outstanding value for the price');
    }

    if (!reasons.length) return 'A strong match based on your playing profile.';
    return reasons.slice(0, 2).map(function (r) { return r.charAt(0).toUpperCase() + r.slice(1); }).join(' · ') + '.';
  }

  // ================================================================
  // INVENTORY CHECK
  // ================================================================

  function checkInventory(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { return d.available !== false; })
      .catch(function () { return true; });
  }

  async function verifyAvailability(products) {
    var checked = await Promise.all(
      products.map(async function (p) {
        var available = await checkInventory(p.handle);
        return Object.assign({}, p, { available: available });
      })
    );
    return checked;
  }

  // ================================================================
  // RENDERING HELPERS
  // ================================================================

  function renderProductCard(product, blurb, small) {
    var imageHtml = product.featured_image
      ? '<img src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '" class="quiz-card__image" loading="lazy" width="120" height="120">'
      : '<div class="quiz-card__image quiz-card__image--placeholder"></div>';

    var compareHtml = product.compare_at_price && product.compare_at_price > product.price
      ? '<span class="quiz-card__compare">' + formatPrice(product.compare_at_price) + '</span>' : '';

    var variantsHtml = '';
    if (product.variants && product.variants.length > 1) {
      variantsHtml = '<div class="quiz-card__variants" role="group" aria-label="Variants">' +
        product.variants.slice(0, 4).map(function (v, i) {
          return '<button class="quiz-card__variant-btn" aria-pressed="' + (i === 0 ? 'true' : 'false') + '">' + escapeHtml(v.title) + '</button>';
        }).join('') + '</div>';
    }

    var ctaHtml = product.available !== false
      ? '<a href="' + product.url + '" class="quiz-card__cta" aria-label="View ' + escapeHtml(product.title) + '">View Product</a>'
      : '<span class="quiz-card__unavailable">Out of Stock</span>';

    return '<div class="quiz-card" data-product-id="' + product.id + '">' +
      '<div class="quiz-card__inner">' +
        '<div class="quiz-card__image-wrap">' + imageHtml + '</div>' +
        '<div class="quiz-card__info">' +
          '<span class="quiz-card__vendor">' + escapeHtml(product.vendor || '') + '</span>' +
          '<a href="' + product.url + '" class="quiz-card__title">' + escapeHtml(product.title) + '</a>' +
          '<div class="quiz-card__pricing">' +
            '<span class="quiz-card__price">' + formatPrice(product.price) + '</span>' + compareHtml +
          '</div>' +
          (blurb ? '<p class="quiz-card__blurb">' + escapeHtml(blurb) + '</p>' : '') +
        '</div>' +
      '</div>' +
      '<div class="quiz-card__footer">' + variantsHtml + ctaHtml + '</div>' +
    '</div>';
  }

  function renderAccCard(product) {
    var imageHtml = product.featured_image
      ? '<img src="' + product.featured_image + '" alt="' + escapeHtml(product.title) + '" class="quiz-acc-card__image" loading="lazy">'
      : '<div class="quiz-acc-card__image"></div>';

    return '<div class="quiz-acc-card">' +
      imageHtml +
      '<div class="quiz-acc-card__info">' +
        '<a href="' + product.url + '" class="quiz-acc-card__title">' + escapeHtml(product.title) + '</a>' +
        '<span class="quiz-acc-card__price">' + formatPrice(product.price) + '</span>' +
      '</div>' +
      '<a href="' + product.url + '" class="quiz-acc-card__cta" aria-label="View ' + escapeHtml(product.title) + '">View</a>' +
    '</div>';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ================================================================
  // QUESTION RENDERING
  // ================================================================

  function renderQuestion() {
    var q = QUESTIONS[state.step];
    if (!q) return;

    var body = document.getElementById('quiz-body');
    if (!body) return;

    var selectedIndices = state.answers[state.step] || [];

    var tooltipHtml = '';
    if (q.tooltip) {
      tooltipHtml = '<div class="quiz__tooltip-area">' +
        '<button class="quiz__tooltip-trigger" id="quiz-tooltip-btn-' + q.index + '" aria-expanded="false" aria-controls="quiz-tooltip-panel-' + q.index + '">' +
          '<span class="quiz__tooltip-icon" aria-hidden="true">?</span> Learn more' +
        '</button>' +
        '<div class="quiz__tooltip-panel" id="quiz-tooltip-panel-' + q.index + '" data-open="false" role="tooltip">' +
          escapeHtml(q.tooltip) +
        '</div>' +
      '</div>';
    }

    var answersHtml = q.answers.map(function (a, i) {
      var pressed = selectedIndices.indexOf(i) >= 0;
      return '<li>' +
        '<button class="quiz__answer" ' +
          'data-index="' + i + '" ' +
          'aria-pressed="' + pressed + '" ' +
          'aria-label="' + escapeHtml(a.label) + '">' +
          escapeHtml(a.label) +
        '</button>' +
      '</li>';
    }).join('');

    var continueHtml = q.multi
      ? '<div class="quiz__continue-wrap">' +
          '<button class="quiz__continue-btn" id="quiz-continue-btn" ' + (selectedIndices.length ? '' : 'disabled') + '>Continue</button>' +
        '</div>'
      : '';

    var multiHint = q.multi ? '<p class="quiz__multi-hint">Select all that apply</p>' : '';

    body.innerHTML =
      '<div class="quiz__question-wrap">' +
        '<span class="quiz__section-label">Section ' + q.section + ' — ' + escapeHtml(q.sectionTitle) + '</span>' +
        '<h2 class="quiz__question-text">' + escapeHtml(q.text) + '</h2>' +
        multiHint +
        tooltipHtml +
        '<ul class="quiz__answers" role="listbox" aria-label="' + escapeHtml(q.text) + '">' + answersHtml + '</ul>' +
        continueHtml +
      '</div>';

    updateProgress();
    updateBackBtn();
    attachQuestionListeners(q);
  }

  function attachQuestionListeners(q) {
    var body = document.getElementById('quiz-body');

    body.querySelectorAll('.quiz__answer').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-index'), 10);
        if (q.multi) {
          toggleMultiAnswer(idx, q);
        } else {
          selectSingleAnswer(idx, q);
        }
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    var tooltipBtn = document.getElementById('quiz-tooltip-btn-' + q.index);
    if (tooltipBtn) {
      tooltipBtn.addEventListener('click', function () {
        var panel = document.getElementById('quiz-tooltip-panel-' + q.index);
        var open = panel.getAttribute('data-open') === 'true';
        panel.setAttribute('data-open', open ? 'false' : 'true');
        tooltipBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    }

    var continueBtn = document.getElementById('quiz-continue-btn');
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!continueBtn.disabled) advance(q);
      });
    }
  }

  function toggleMultiAnswer(answerIdx, q) {
    var current = (state.answers[state.step] || []).slice();
    var pos = current.indexOf(answerIdx);
    if (pos >= 0) current.splice(pos, 1);
    else current.push(answerIdx);
    state.answers[state.step] = current;

    var body = document.getElementById('quiz-body');
    body.querySelectorAll('.quiz__answer').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-index'), 10);
      btn.setAttribute('aria-pressed', current.indexOf(i) >= 0 ? 'true' : 'false');
    });

    var continueBtn = document.getElementById('quiz-continue-btn');
    if (continueBtn) continueBtn.disabled = current.length === 0;
  }

  function selectSingleAnswer(answerIdx, q) {
    state.answers[state.step] = [answerIdx];
    var body = document.getElementById('quiz-body');
    body.querySelectorAll('.quiz__answer').forEach(function (btn) {
      var i = parseInt(btn.getAttribute('data-index'), 10);
      btn.setAttribute('aria-pressed', i === answerIdx ? 'true' : 'false');
    });
    setTimeout(function () { advance(q); }, 160);
  }

  function advance(q) {
    var selectedIndices = state.answers[state.step] || [];
    if (!selectedIndices.length) return;

    pushHistory();

    selectedIndices.forEach(function (idx) {
      var tag = q.answers[idx] && q.answers[idx].tag;
      if (tag && state.tags.indexOf(tag) < 0) state.tags.push(tag);
    });

    state.step++;

    if (state.step >= QUESTIONS.length) {
      showLoading();
      computeAndRender(state.tags);
    } else {
      renderQuestion();
    }
  }

  // ================================================================
  // PROGRESS & NAV
  // ================================================================

  function updateProgress() {
    var label = document.getElementById('quiz-progress-label');
    var bar = document.getElementById('quiz-progress-bar');
    var sectionLabel = document.getElementById('quiz-section-label');
    var progressWrap = document.querySelector('.quiz__progress');
    var q = QUESTIONS[state.step];

    var pct = Math.round((state.step / QUESTIONS.length) * 100);
    if (label) label.textContent = 'Question ' + (state.step + 1) + ' of ' + QUESTIONS.length;
    if (bar) bar.style.width = pct + '%';
    if (progressWrap) {
      progressWrap.setAttribute('aria-valuenow', state.step);
      progressWrap.setAttribute('aria-valuetext', 'Question ' + (state.step + 1) + ' of ' + QUESTIONS.length);
    }
    if (sectionLabel && q) sectionLabel.textContent = 'Section ' + q.section + ': ' + q.sectionTitle;
  }

  function updateBackBtn() {
    var btn = document.getElementById('quiz-back-btn');
    if (btn) btn.setAttribute('data-visible', historyStack.length > 0 ? 'true' : 'false');
  }

  // ================================================================
  // LOADING
  // ================================================================

  function showLoading() {
    var body = document.getElementById('quiz-body');
    if (!body) return;
    var label = document.getElementById('quiz-progress-label');
    var bar = document.getElementById('quiz-progress-bar');
    if (label) label.textContent = 'Finding your best matches…';
    if (bar) bar.style.width = '100%';
    body.innerHTML = '<div class="quiz__loading"><div class="quiz__spinner" aria-hidden="true"></div><p>Analyzing your answers…</p></div>';
  }

  // ================================================================
  // RESULTS RENDERING
  // ================================================================

  async function computeAndRender(tags) {
    var recs = getRecommendations(tags);

    if (recs.cues.length) {
      recs.cues = await verifyAvailability(recs.cues);
    }
    if (recs.cases.length) {
      recs.cases = await verifyAvailability(recs.cases);
    }

    var unavailableCueIds = recs.cues.filter(function (p) { return !p.available; }).map(function (p) { return p.id; });
    if (unavailableCueIds.length) {
      var products = (window.CuesAndMore && window.CuesAndMore.products) || [];
      var allCueScored = scoreProducts(filterCues(products, tags), tags);
      var replacements = allCueScored.map(function (s) { return s.product; })
        .filter(function (p) { return !recs.cues.some(function (c) { return c.id === p.id; }); });
      var ri = 0;
      recs.cues = recs.cues.map(function (p) {
        if (!p.available && ri < replacements.length) return replacements[ri++];
        return p;
      });
    }

    renderResults(tags, recs);
  }

  function renderResults(tags, recs) {
    var body = document.getElementById('quiz-body');
    if (!body) return;

    var progressWrap = document.querySelector('.quiz__progress');
    if (progressWrap) progressWrap.setAttribute('aria-valuenow', '20');
    var label = document.getElementById('quiz-progress-label');
    if (label) label.textContent = 'Your Results';
    var bar = document.getElementById('quiz-progress-bar');
    if (bar) bar.style.width = '100%';
    var sectionLabel = document.getElementById('quiz-section-label');
    if (sectionLabel) sectionLabel.textContent = '';
    updateBackBtn();

    var profile = getProfile(tags);
    var weightGuide = getWeightGuidance(tags);
    var shaftGuide = getShaftDiameterGuidance(tags);
    var ldTier = getTagValue(tags, 'ld');

    var profileTagsDisplay = tags
      .filter(function (t) { return ['skill', 'freq', 'style', 'game', 'venue', 'cuebudget'].some(function (k) { return t.indexOf(k + '=') === 0; }); })
      .map(function (t) { return t.replace(/.*=/, ''); })
      .map(function (v) { return '<span class="quiz__profile-tag">' + escapeHtml(v) + '</span>'; })
      .join('');

    var cueCardsHtml = recs.cues.length
      ? recs.cues.map(function (p) { return renderProductCard(p, generateBlurb(p, tags), false); }).join('')
      : '<div class="quiz__empty">No cues found for your exact criteria. <a href="/collections/cues" class="quiz__ld-link">Browse all cues</a></div>';

    var caseCardsHtml = recs.cases.length
      ? recs.cases.map(function (p) { return renderProductCard(p, null, false); }).join('')
      : '<div class="quiz__empty">No cases found. <a href="/collections/cases" class="quiz__ld-link">Browse all cases</a></div>';

    var accCardsHtml = recs.accessories.length
      ? recs.accessories.map(renderAccCard).join('')
      : '';

    var ldHtml = '';
    if (ldTier && ldTier !== 'no') {
      var ldTitle = { unknown: 'What is a Low-Deflection Shaft?', curious: 'Low-Deflection Shafts: Worth a Look', interested: 'Recommended Low-Deflection Shafts', upgrade: 'Top Carbon Fiber Shaft Upgrades' }[ldTier] || 'Low-Deflection Shafts';
      var ldBody = '';
      if (ldTier === 'unknown') {
        ldBody = 'A low-deflection (LD) shaft is engineered to reduce cue ball deflection when you apply side spin. This makes your shots more predictable and improves accuracy at longer distances. <a href="/pages/learn/low-deflection-shafts" class="quiz__ld-link">Learn more &rarr;</a>';
      } else if (recs.shafts.length) {
        ldBody = recs.shafts.map(function (p) { return renderProductCard(p, null, false); }).join('');
      } else {
        ldBody = 'Explore our shaft selection to find the right LD upgrade for your cue. <a href="/collections/shafts" class="quiz__ld-link">Browse shafts &rarr;</a>';
      }
      ldHtml = '<div class="quiz__results-section">' +
        '<h3 class="quiz__results-heading">' + ldTitle + '</h3>' +
        '<div class="quiz__ld">' +
          (ldTier === 'unknown' ? '<p class="quiz__ld-body">' + ldBody + '</p>' : ldBody) +
        '</div>' +
      '</div>';
    }

    var contactUrl = (window.CuesAndMore && window.CuesAndMore.contactUrl) || '/pages/contact';

    body.innerHTML =
      '<div class="quiz__results">' +
        '<p class="quiz__results-title">Your Player Fit Results</p>' +

        '<div class="quiz__profile-card">' +
          '<h2 class="quiz__profile-name">' + escapeHtml(profile.name) + '</h2>' +
          '<p class="quiz__profile-desc">' + escapeHtml(profile.desc) + '</p>' +
          (profileTagsDisplay ? '<div class="quiz__profile-tags" aria-label="Your profile tags">' + profileTagsDisplay + '</div>' : '') +
        '</div>' +

        '<div class="quiz__results-section">' +
          '<h3 class="quiz__results-heading">Recommended Cues</h3>' +
          '<div class="quiz-cards">' + cueCardsHtml + '</div>' +
        '</div>' +

        '<div class="quiz__results-section">' +
          '<h3 class="quiz__results-heading">Weight &amp; Shaft Diameter Guidance</h3>' +
          '<div class="quiz__guidance">' +
            '<p class="quiz__guidance-heading">Based on your playing style</p>' +
            '<div class="quiz__guidance-row"><span class="quiz__guidance-label">Recommended weight:</span><span class="quiz__guidance-value">' + escapeHtml(weightGuide.range) + ' — ' + escapeHtml(weightGuide.explanation) + '</span></div>' +
            '<div class="quiz__guidance-row"><span class="quiz__guidance-label">Shaft diameter:</span><span class="quiz__guidance-value">' + escapeHtml(shaftGuide.range) + ' — ' + escapeHtml(shaftGuide.explanation) + '</span></div>' +
          '</div>' +
        '</div>' +

        ldHtml +

        '<div class="quiz__results-section">' +
          '<h3 class="quiz__results-heading">Recommended Cases</h3>' +
          '<div class="quiz-cards">' + caseCardsHtml + '</div>' +
        '</div>' +

        (accCardsHtml ? '<div class="quiz__results-section">' +
          '<h3 class="quiz__results-heading">Accessories</h3>' +
          '<div class="quiz__acc-row">' + accCardsHtml + '</div>' +
        '</div>' : '') +

        '<div class="quiz__actions">' +
          '<button class="quiz__btn quiz__btn--ghost" id="quiz-restart-btn">&#8635; Start Over</button>' +
          '<button class="quiz__btn quiz__btn--save" id="quiz-save-btn">Save My Results</button>' +
          '<a href="' + escapeHtml(contactUrl) + '" class="quiz__btn quiz__btn--expert">Talk to an Expert</a>' +
        '</div>' +
      '</div>';

    attachResultListeners(tags);
  }

  function attachResultListeners(tags) {
    var restartBtn = document.getElementById('quiz-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        resetState();
        renderQuestion();
      });
    }

    var saveBtn = document.getElementById('quiz-save-btn');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var encoded = encodeURIComponent(tags.join(','));
        var url = window.location.href.split('?')[0] + '?quiz=' + encoded;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            saveBtn.textContent = 'Link Copied!';
            setTimeout(function () { saveBtn.textContent = 'Save My Results'; }, 2500);
          });
        } else {
          window.prompt('Copy your results link:', url);
        }
      });
    }

    document.querySelectorAll('.quiz-card__variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.quiz-card__variants');
        if (!group) return;
        group.querySelectorAll('.quiz-card__variant-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  }

  // ================================================================
  // URL RESTORE
  // ================================================================

  function tryRestoreFromUrl() {
    var match = window.location.search.match(/[?&]quiz=([^&]+)/);
    if (!match) return false;
    try {
      var tags = decodeURIComponent(match[1]).split(',').filter(Boolean);
      if (!tags.length) return false;
      state.tags = tags;
      showLoading();
      computeAndRender(tags);
      return true;
    } catch (e) {
      return false;
    }
  }

  // ================================================================
  // INIT
  // ================================================================

  function init() {
    var container = document.getElementById('player-fit-quiz');
    if (!container) return;

    resetState();

    var backBtn = document.getElementById('quiz-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (popHistory()) renderQuestion();
      });
    }

    if (!tryRestoreFromUrl()) {
      renderQuestion();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
